const common = {
  start: "Iniciar",
  error: "Error",
  warning: "Advertencia",
  success: "Éxito",
  info: "Información",
  loading: "Cargando",
  cancel: "Cancelar",
  update: "Actualizar",
  share: "Compartir",
  save: "Guardar",
  edit: "Editar",
  preview: "Vista previa",
  create: "Crear",
  delete: "Eliminar",
  add: "Agregar",
  apply: "Aplicar",
  close: "Cerrar",
  next: "Siguiente",
  previous: "Anterior",
  finish: "Finalizar",
  back: "Atrás",
  done: "Hecho",
  ok: "OK",
  confirm: "Confirmar",
  continue: "Continuar",
  explore: "Explorar",
  accept: "Aceptar",
  reject: "Rechazar",
  submit: "Enviar",
  select: "Seleccionar",
  search: "Buscar",
  filter: "Filtrar",
  clear: "Limpiar",
  reset: "Restablecer",
  refresh: "Actualizar",
  retry: "Reintentar",
  download: "Descargar",
  downloading: "Descargando",
  upload: "Subir",
  copy: "Copiar",
  paste: "Pegar",
  cut: "Cortar",
  undo: "Deshacer",
  redo: "Rehacer",
  yes: "Sí",
  no: "No",
  enable: "Habilitar",
  disable: "Deshabilitar",
  show: "Mostrar",
  hide: "Ocultar",
  expand: "Expandir",
  collapse: "Colapsar",
  minimize: "Minimizar",
  maximize: "Maximizar",
  restore: "Restaurar",
  lock: "Bloquear",
  unlock: "Desbloquear",
  open: "Abrir",
  "label.manage": "Gestionar",
  "no-data": "No hay datos disponibles",
  "init.timeout.title": "No se pudo conectar",
  "init.timeout.message": "La conexión ha expirado. Por favor, comprueba tu red e inténtalo de nuevo.",
  max: "Máximo",
  available: "Disponible",
  expired: "Expirado",
  "currently-unavailable": "Actualmente no disponible",
  "not-available": "No disponible",
  published: "Publicado",
  "not-published": "No publicado",
  version: "Versión",
  "sign-out": "Cerrar Sesión",
  "select-plan": "Comprar Suscripción",
  play: "Jugar",
  skip: "Omitir",
};

const domain = {
  "be-your-best": "Be Your Best",
  "session.label": "Sesión",
  "sessions.label": "Sesiones",
  "scenario.label": "Situación",
  "scenarios.label": "Situaciones",
  "training.label": "Entrenamiento",
  "challenge.label": "Desafío",
  "challenges.label": "Desafíos",
  "match.label": "Partido",
  "matches.label": "Partidos",
  "game.label": "Juego",
  "games.label": "Juegos",
  "drill.label": "Ejercicio",
  "drills.label": "Ejercicios",

  "career.label": "Carrera",

  "league.label": "Liga",
  "leagues.label": "Ligas",
  "league.specific": "Liga {{ league }}",
  "league.bootcamp.name": "Bootcamp",
  "league.bootcamp.short": "Bootcamp",
  "league.bronze.name": "Liga Bronce",
  "league.bronze.short": "Bronce",
  "league.silver.name": "Liga Plata",
  "league.silver.short": "Plata",
  "league.gold.name": "Liga Oro",
  "league.gold.short": "Oro",
  "league.champions.name": "Liga de Campeones",
  "league.champions.short": "Campeones",

  "division.label": "División",
  "divisions.label": "Divisiones",
  "division.specific": "División {{ division }}",
  "bybiq.label": "BYB IQ",
  "rating.label": "Calificación",
  "rating-points.label": "Puntos de Calificación",
  "comparison.label": "Comparación",

  "position.label": "Posición",
  "position.player": "Jugador",
  "position.players": "Jugadores",
  "position.unknown": "Sin Posición",
  "position.overall": "Tu resultado global",
  "position.goalkeeper": "Portero",
  "position.left_fullback": "Lateral Izquierdo",
  "position.center_back": "Defensa Central",
  "position.right_back": "Lateral Derecho",
  "position.left_back": "Lateral Izquierdo",
  "position.right_center_back": "Central Derecho",
  "position.left_center_back": "Central Izquierdo",
  "position.right_fullback": "Lateral Derecho",
  "position.center_midfielder": "Centrocampista",
  "position.left_center_midfielder": "Centrocampista Central Izquierdo",
  "position.right_center_midfielder": "Centrocampista Central Derecho",
  "position.defensive_midfielder": "Centrocampista Defensivo",
  "position.attacking_midfielder": "Centrocampista Ofensivo",
  "position.striker": "Delantero",
  "position.left_winger": "Extremo Izquierdo",
  "position.right_winger": "Extremo Derecho",

  "position.short.goalkeeper": "PT",
  "position.short.left_fullback": "LI",
  "position.short.center_back": "DC",
  "position.short.right_center_back": "DCD",
  "position.short.left_center_back": "DCI",
  "position.short.right_fullback": "LD",
  "position.short.center_midfielder": "CC",
  "position.short.left_center_midfielder": "CCI",
  "position.short.right_center_midfielder": "CCD",
  "position.short.defensive_midfielder": "CD",
  "position.short.attacking_midfielder": "CO",
  "position.short.striker": "DL",
  "position.short.left_winger": "EI",
  "position.short.right_winger": "ED",

  "position.defensive": "Defensivo",
  "position.midfield": "Mediocampo",
  "position.forward": "Delantero",

  "phase.attacking": "Ataque",
  "phase.build_up": "Salida de balón",
  "phase.counter_attack": "Contraataque",

  "session-type.playlist_session": "Lista de Reproducción",
  "session-type.progression_session": "Carrera",
  "session-type.practise_session": "Práctica",
  "session-type.challenge_session": "Desafío",
  "session-type.private_session": "Entrenamiento Privado",
  "session-type.matchplay_session": "Partido",
};

const metrics = {
  "metric.awareness.name": "Memoria",
  "metric.awareness.name.initials": "M",
  "metric.awareness.long": "%",
  "metric.awareness.short": "%",

  "metric.decision.name": "Decisión",
  "metric.decision.name.initials": "D",
  "metric.decision.long": "%",
  "metric.decision.short": "%",

  "metric.critical_scan.name": "Escan Crítico",
  "metric.critical_scan.name.initials": "EC",
  "metric.critical_scan.long": "ESC/R",
  "metric.critical_scan.short": "ESC/R",

  "metric.scan_timing.name": "Ritmo",
  "metric.scan_timing.name.initials": "R",
  "metric.scan_timing.long": "%",
  "metric.scan_timing.short": "%",

  "metric.scan_frequency.name": "Frecuencia",
  "metric.scan_frequency.name.initials": "F",
  "metric.scan_frequency.long": "escans/s",
  "metric.scan_frequency.short": "escans/s",

  "metric.byb_iq.name": "BYB IQ",
  "metric.byb_iq.long": "BYB IQ",
  "metric.byb_iq.short": "",
  "metric.byb_iq": "BYB IQ",

  "metric.gameplay_duration.name": "Duración de Juego",
  "metric.gameplay_duration.minutes.long": "min(s)",
  "metric.gameplay_duration.minutes.short": "min(s)",
  "metric.gameplay_duration.seconds.long": "seg(s)",
  "metric.gameplay_duration.seconds.short": "seg(s)",

  "metric.passes_score.name": "Decisión",
  "metric.passes_score.long": "%",
  "metric.passes_score.short": "%",

  "metric.scan_rate.name": "Frecuencia",
  "metric.scan_rate.long": "escans/s",
  "metric.scan_rate.short": "escans/s",

  "metric.critical_scan_score.name": "Escan Crítico",
  "metric.critical_scan_score.long": "ESC/R",
  "metric.critical_scan_score.short": "ESC/R",

  "metric.awareness_score.name": "Memoria",
  "metric.awareness_score.long": "%",
  "metric.awareness_score.short": "%",

  "metric.total_score.name": "Puntuación Total",
  "metric.total_score.long": "%",
  "metric.total_score.short": "%",

  "metric.score.name": "Puntuación",
  "metric.score.long": "%",
  "metric.score.short": "%",
};

const stats = {
  "stats.activity.label": "Actividad",
  "stats.activity.subtitle": "Minutos",
  "stats.training.label": "Entrenamiento",
  "stats.training.subtitle": "Sesiones",
  "stats.weekly_training.label": "Meta semanal",
  "stats.weekly_training.subtitle": "Minutos",
};

const performance = {
  "performance.label.excellent": "Excelente",
  "performance.label.great": "Grande",
  "performance.label.good": "Bueno",
  "performance.label.average": "Promedio",
  "performance.label.below_average": "Por debajo del promedio",
  "performance.label.strong": "Fuerte",
  "performance.label.fair": "Aceptable",
  "performance.label.poor": "Pobre",
  "performance.label.building": "Construyendo",
  "performance.label.learning": "Aprendiendo",
};

const time = {
  second: "segundo",
  seconds: "segundos",
  minute: "minuto",
  minutes: "minutos",
  min: "min",
  mins: "mins",
  hour: "hora",
  hours: "horas",
  day: "día",
  days: "días",
  daily: "diario",
  week: "semana",
  weeks: "semanas",
  weekly: "semanal",
  month: "mes",
  months: "meses",
  monthly: "mensual",
  year: "año",
  years: "años",
  yearly: "anual",

  "week-short": "sem",
  "hours-short": "hrs",
  "minutes-short": "mins",
  "seconds-short": "segs",

  "minutes-extra-short": "m",
  "seconds-extra-short": "s",
  "hours-extra-short": "h",
  "days-extra-short": "d",
  "weeks-extra-short": "sem",
  "months-extra-short": "m",
  "years-extra-short": "a",

  "minutes-extra-short-capitalized": "M",
  "seconds-extra-short-capitalized": "S",
  "hours-extra-short-capitalized": "H",

  "period.daily": "Diario",
  "period.weekly": "Semanal",
  "period.monthly": "Mensual",
  "period.quarterly": "Trimestral",
  "period.yearly": "Anual",
  "period.all_time": "Todo el Tiempo",
};

const date = {
  "month.number.1": "Ene",
  "month.number.2": "Feb",
  "month.number.3": "Mar",
  "month.number.4": "Abr",
  "month.number.5": "May",
  "month.number.6": "Jun",
  "month.number.7": "Jul",
  "month.number.8": "Ago",
  "month.number.9": "Sep",
  "month.number.10": "Oct",
  "month.number.11": "Nov",
  "month.number.12": "Dic",

};

const gender = {
  "gender.label": "Género",
  "gender.male": "Masculino",
  "gender.female": "Femenino",
  "gender.na": "N/A",
};

const filters = {
  "filter-by.label": "Filtrar por",
  "filter-by.metric.label": "Filtrar",
  "filter-by.period.label": "Filtrar por periodo",
  "filter-by.period.short": "Periodo",
  "filter-by.location.short": "Ubicación",
  "filter-by.age.short": "Edad",
  "filter-by.result.label": "Filtrar por resultado",
};

const ordinals = {
  "ordinal.1": "º",
  "ordinal.2": "º",
  "ordinal.3": "º",
  "ordinal.default": "º",
  "ordinal.11": "º",
  "ordinal.12": "º",
  "ordinal.13": "º",
};

export const dictionary = {
  ...common,
  ...domain,
  ...metrics,
  ...stats,
  ...time,
  ...date,
  ...gender,
  ...performance,
  ...filters,
  ...ordinals,
};
